// Shared validation for settings and authoritative public projection.
export function normalizeBrandingWebsite(value) {
  if (value == null || value === '') return null;
  const invalid = () => { throw Object.assign(new Error('Enter a full website address beginning with https:// or http://.'), { status: 400 }); };
  if (typeof value !== 'string') return invalid();
  const text = value.trim();
  if (!text) return null;
  if (text.length > 2048 || !/^https?:\/\//i.test(text) || /[\s\\\u0000-\u001f\u007f]/.test(text)) return invalid();
  let url;
  try { url = new URL(text); } catch { return invalid(); }
  if (!['https:', 'http:'].includes(url.protocol) || !url.hostname || url.username || url.password || url.href.length > 2048) return invalid();
  return url.href;
}
